import disneyland from './ca-dl.png'
import dca from './ca-dca.png'

const CALIFORNIAPARKS = [
    {
        name: 'Disneyland',
        location: 'Anaheim, California',
        img: disneyland,
        alt: 'Relevant photo of Disney park',
        linkto: '/disneyland',
    },
    {
        name: 'California Adventure',
        location: 'Anaheim, California',
        img: dca,
        alt: 'Picture of California Adventure',
        linkto: '/californiaadventure',
    }
]

export default CALIFORNIAPARKS;